var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scroll-pane",
    { attrs: { "scroll-event": "routes:init" } },
    [
      _c("action-header", { attrs: { slot: "header" }, slot: "header" }, [
        _c(
          "div",
          { staticClass: "search" },
          [
            _c("VueIcon", { attrs: { icon: "search" } }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.filter,
                  expression: "filter",
                  modifiers: { trim: true }
                }
              ],
              ref: "filterRoutes",
              attrs: { placeholder: "Filter routes" },
              domProps: { value: _vm.filter },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.filter = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ],
          1
        ),
        _c(
          "a",
          {
            staticClass: "button reset",
            class: { disabled: !_vm.filteredRoutes.length },
            on: { click: _vm.reset }
          },
          [
            _c("VueIcon", {
              staticClass: "small",
              attrs: { icon: "do_not_disturb" }
            }),
            _c("span", [_vm._v("Clear")])
          ],
          1
        ),
        _c(
          "a",
          {
            staticClass: "button toggle-recording",
            on: { click: _vm.toggleRecording }
          },
          [
            _c("VueIcon", {
              staticClass: "small",
              class: { enabled: _vm.enabled },
              attrs: { icon: "lens" }
            }),
            _c("span", [_vm._v(_vm._s(_vm.enabled ? "Recording" : "Paused"))])
          ],
          1
        )
      ]),
      _c(
        "RecycleScroller",
        {
          staticClass: "history",
          class: {
            "high-density": _vm.highDensity
          },
          attrs: {
            slot: "scroll",
            items: _vm.filteredRoutes,
            "item-size": _vm.highDensity ? 22 : 34
          },
          slot: "scroll",
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var route = ref.item
                var index = ref.index
                var active = ref.active
                return [
                  _c(
                    "div",
                    {
                      staticClass: "entry list-item",
                      class: { active: _vm.inspectedIndex === index },
                      attrs: { "data-active": active },
                      on: {
                        click: function($event) {
                          _vm.inspect(_vm.routeChanges.indexOf(route))
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "route-name" }, [
                        _vm._v(_vm._s(route.to.path))
                      ]),
                      _c("span", { staticClass: "time" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatTime")(
                              route.timestamp,
                              _vm.$shared.timeFormat
                            )
                          )
                        )
                      ]),
                      route.to.redirectedFrom
                        ? _c("span", { staticClass: "label redirect" }, [
                            _vm._v("\n          redirect\n        ")
                          ])
                        : _vm._e(),
                      _vm.isNotEmpty(route.to.name)
                        ? _c("span", { staticClass: "label name" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(route.to.name) +
                                "\n        "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _vm.filteredRoutes.length === 0
            ? _c(
                "div",
                {
                  staticClass: "no-routes",
                  attrs: { slot: "after-container" },
                  slot: "after-container"
                },
                [
                  _vm._v("\n      No route transitions found"),
                  !_vm.enabled
                    ? _c("span", [_c("br"), _vm._v("(Recording is paused)")])
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }